import { b as addItemById, a as contexts } from './cart-e7eff8c7.js';
import { E as EVENTS } from './events-80a90688.js';

class ProductBlockComplementaryProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      block: "[js-product-block-complementary-products-component]",
      item: "[js-complementary-product-item]",
      itemAddButton: "[js-complementary-product-item-add]",
      itemError: "[js-complementary-product-item-error]",
      sliderComponent: "[js-scroll-slider-component]",
      slider: "[js-scroll-slider]",
    };

    this.classes = {
      active: "active",
      adding: "adding",
      success: "success",
      hasError: "has-error",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    if (this.dataset.productSource === "app") {
      this.#loadAppProducts();
    } else {
      this.#initItemAddButtons();
    }
  }

  #loadAppProducts() {
    const url = `${window.theme.routes.productRecommendations}?section_id=${this.dataset.sectionId}&limit=${this.dataset.maxProducts}&product_id=${this.dataset.productId}&intent=complementary`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const newSliderComponent = doc.querySelector(
          `${this.selectors.block} ${this.selectors.sliderComponent}`,
        );
        const items = newSliderComponent.querySelectorAll(this.selectors.item);

        if (items.length > 0) {
          const sliderComponent = this.querySelector(
            this.selectors.sliderComponent,
          );

          sliderComponent.replaceWith(newSliderComponent);
          this.#initItemAddButtons();
        } else {
          if (!Shopify.designMode) {
            this.style.display = "none";
          }
        }
      });
  }

  #initItemAddButtons() {
    this.itemAddButtons = this.querySelectorAll(this.selectors.itemAddButton);
    this.itemAddButtons.forEach((button) => {
      button.addEventListener("click", this.#handleItemAdd.bind(this), {
        signal: this.controller.signal,
      });

      // If the item has no variants, we need to listen for cart success/failure events
      if (button.dataset.hasVariants === "false") {
        const item = button.closest(this.selectors.item);

        item.addEventListener(
          EVENTS.QUICK_ADD_SUCCESS,
          this.#handleItemAddSuccess.bind(this),
          { signal: this.controller.signal },
        );

        item.addEventListener(
          EVENTS.QUICK_ADD_ERROR,
          this.#handleItemAddError.bind(this),
          { signal: this.controller.signal },
        );
      }
    });
  }

  #handleItemAdd(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const item = button.closest(this.selectors.item);
    const hasVariants = button.dataset.hasVariants === "true";

    if (hasVariants) {
      // TODO: Hook up quick view modal
      alert("Should open quick view");
    } else {
      button.classList.add(this.classes.active, this.classes.adding);

      addItemById(
        button.dataset.variantId,
        1,
        contexts.productItem,
        item,
      );
    }
  }

  #handleItemAddSuccess(event) {
    const button = event.target.querySelector(this.selectors.itemAddButton);

    button.classList.remove(this.classes.adding);
    button.classList.add(this.classes.success);

    setTimeout(() => {
      button.classList.remove(this.classes.success, this.classes.active);
    }, 400);
  }

  #handleItemAddError(event) {
    const button = event.target.querySelector(this.selectors.itemAddButton);
    const errorEl = event.target.querySelector(this.selectors.itemError);

    button.classList.remove(this.classes.active, this.classes.adding);
    errorEl.innerText = event.detail.errorMessage;
    event.target.classList.add(this.classes.hasError);
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("product-block-complementary-products")) {
  customElements.define(
    "product-block-complementary-products",
    ProductBlockComplementaryProducts,
  );
}
